import React, { useEffect, useState } from 'react'
import { Tooltip } from 'react-tooltip'

// Tranlations
import t from '../translations'

export const useInstallPrompt = (lang) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null)

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt()
            deferredPrompt.userChoice.then((choiceResult) => {
                setDeferredPrompt(null)
            })
        }
    }

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault()
            setDeferredPrompt(e)
        }

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
        }
    }, [])

    return deferredPrompt ? <div className='AppInstall' onClick={handleInstallClick}>
        <Tooltip id='installAppIcon'/>
        <box-icon
            type='regular'
            name='heart'
            color='#f15deaff'
            data-tooltip-id='installAppIcon'
            data-tooltip-content={t[lang]['installButton']}
            data-tooltip-place='right'
        />
    </div> : <></>
}